import { Link } from "react-router-dom";

export const Brand = ({ to = "/", sub }) => (
  <Link to={to} data-testid="brand-logo" className="flex items-center gap-3 group">
    <img src={`${process.env.PUBLIC_URL}/logo-app.png`} alt="Aurora School" className="w-9 h-9 rounded-lg transition-transform duration-150 group-hover:scale-110" />
    <span className="leading-none">
      <span className="block font-display font-extrabold tracking-tight text-lg text-zinc-950">Aurora School</span>
      {sub && <span className="block font-mono text-[10px] uppercase tracking-widest text-zinc-500 mt-1">{sub}</span>}
    </span>
  </Link>
);
